"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHTMLElement = isHTMLElement;
function isHTMLElement(ref) {
    const svgNamespace = 'http://www.w3.org/2000/svg';
    return ref !== undefined &&
        typeof ref === 'object' &&
        ref.nodeType === 1 &&
        ref.namespaceURI !== svgNamespace;
}
